/**
 * On first facetwp initialization pre-load any already-active facets for this page
 */
import { getFiltered } from './partners-feed-filter'

export const partnersFeedInitialize = (feed) => {
	const { FWP, elWrap, elCats } = feed
	// if facetwp does not have its own pre-filters (i.e. query params)
	if (!FWP.facets.partner_category?.length) {
		// if we have user-supplied pre-filter values
		const { category: userCat, subcategory: userSubCat } = elWrap.dataset
		if (userCat) {
			// pre-filter our results and then show them
			document.addEventListener(
				'facetwp-loaded',
				() => {
					elWrap.classList.remove('is-loading')
				},
				{ passive: true, once: true }
			)
			getFiltered(feed, {
				partner_category: [userCat],
				partner_subcategory: userSubCat ? [userSubCat] : [],
			})
		}
	} else {
		elWrap.classList.remove('is-loading')
	}
	// visually show pre-checks for categories
	if (FWP.facets.partner_category?.length) {
		const catName = FWP.facets.partner_category[0]
		const elCur = elCats.querySelector(`[value=${catName}]`)
		if (elCur) {
			elCur.checked = true
			elCats.dataset.cat = catName
		}
	} else {
		// identify all as being shown
		elCats.dataset.cat = 'all'
	}
}
